import { SelectGroup, SelectOption } from '@patternfly/react-core'
import styled from 'styled-components'

export const StyledSelectGroup = styled(SelectGroup)`
  .pf-c-select__menu-group-title {
    text-transform: uppercase;
    font-size: 0.85rem;
    text-decoration: underline;
    letter-spacing: 0.05em;
  }
`
export const StyledSelectOption = styled(SelectOption)<{
  $isNearest?: boolean
  $activeColor?: string
}>`
  margin-bottom: 0.5rem;
  line-height: 1;
  font-size: 1rem;

  .pf-c-select__menu-item-main {
    font-weight: normal;
  }

  .pf-c-select__menu-item-description {
    font-size: 0.85rem;
    ${(props) =>
      props.$isNearest && props.$activeColor
        ? `color: ${props.$activeColor};`
        : ''}
  }

  ${(props) =>
    props.$isNearest && props.$activeColor
      ? `color: ${props.$activeColor};`
      : ''}

  &:last-child {
    margin-bottom: 0;
  }
`

export const InteractionLabel = styled.span<{ $strikeThrough?: boolean }>`
  ${(props) => (props.$strikeThrough ? 'text-decoration: line-through;' : '')}
`
